import { useLocalization } from '@/data/Localization';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { HelloretailProductsSort } from './Sort';
import { HelloretailPagination } from './Pagination';

export const HelloRetailResultsHeader: FC<{total:number}> = ({total}) => {
	const productGridNLS = useLocalization('ProductGrid').Labels;
	return (
		<Stack direction="row" justifyContent="space-between" alignItems="center" my={2} width="100%">
			{total && total > 0 ? <>
			<Typography fontSize={16} color="#424242">
				{productGridNLS.ProductsCount.t({count: total || 0 })}
			</Typography>
			<HelloretailPagination />
			<HelloretailProductsSort /> </> : null}
		</Stack>
	);
};
